const NavConstants = {
    HOME: '/',
    ABOUT: '/about',
    SEARCH: '/search',
    REQUEST_LIST: '/requestlist',
    CONTACT: '/contact'
}

export default NavConstants